import { Link } from 'react-router-dom';
import '../css/Footer.css';
import logo from '../pics/logo.svg';

function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer__container">
        <div className="footer__top">
          <div className="footer__brand">
            <Link to="/" className="footer__logo">
              <img src={logo} alt="Fix'n More" className="footer__logo-img" />
              <span className="footer__logo-text">Fix<span className="footer__logo-accent">'n</span> More</span>
            </Link>
            <p className="footer__brand-desc">
              Professional cell phone & device repair in Huber Heights, OH.
              16+ years of experience — quality parts, fast service, best prices in town.
            </p>
            <a href="tel:9372350298" className="footer__phone">(937) 235-0298</a>
          </div>

          <div className="footer__col">
            <h4 className="footer__col-title">Services</h4>
            <ul className="footer__list">
              <li><Link to="/services">Screen Repair</Link></li>
              <li><Link to="/services">Battery Replacement</Link></li>
              <li><Link to="/services">Charging Port Repair</Link></li>
              <li><Link to="/services">Water Damage Repair</Link></li>
              <li><Link to="/services">Camera Repair</Link></li>
              <li><Link to="/services">Back Glass Repair</Link></li>
            </ul>
          </div>

          <div className="footer__col">
            <h4 className="footer__col-title">Quick Links</h4>
            <ul className="footer__list">
              <li><Link to="/">Home</Link></li>
              <li><Link to="/services">All Services</Link></li>
              <li><Link to="/about">About Us</Link></li>
              <li><Link to="/quote">Get a Quote</Link></li>
              <li><Link to="/contact">Contact & Hours</Link></li>
            </ul>
          </div>

          <div className="footer__col">
            <h4 className="footer__col-title">Location</h4>
            <div className="footer__address">
              <p>8239 Troy Pike</p>
              <p>Huber Heights, OH 45424</p>
              <p className="footer__address-note">Next to Marshall's · NorthPark Center</p>
            </div>
            <div className="footer__hours-mini">
              <p><strong>Mon – Fri:</strong> 10 AM – 7 PM</p>
              <p><strong>Saturday:</strong> 10 AM – 7 PM</p>
              <p><strong>Sunday:</strong> 12 PM – 4 PM</p>
            </div>
          </div>
        </div>

        <div className="footer__bottom">
          <p className="footer__copy">© {year} Fix'n More. All rights reserved. · Huber Heights, OH</p>
          <div className="footer__badges">
            <span className="footer__badge">5.0 Google Rating</span>
            <span className="footer__badge">16+ Years Experience</span>
            <span className="footer__badge">Repair Warranty</span>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
